// Generic success dialog usable across components
import { Component, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SuccessDialogData {
  title?: string;
  desc?: string;
}

@Component({
  selector: 'ers-success-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule],
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.scss'],
})
export class SuccessDialogComponent {
  title: string;
  desc: string;

  constructor(
    public dialogRef: MatDialogRef<SuccessDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data?: SuccessDialogData,
  ) {
    this.title = data?.title ?? 'Your Leave Request has submitted successfully!';
    this.desc  = data?.desc  ?? 'Your request has been sent for approval, we\'ll notify you once your manager takes action.';
  }

  close() {
    this.dialogRef.close();
  }
}
